import { useContext } from 'react';
import { EstablishmentLocationChartsDataContext } from '../contexts/EstablishmentLocationChartsDataContext';

export const useEstablishmentLocationChartsDataContext = () => {
    return useContext(EstablishmentLocationChartsDataContext);
};
